///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
export const DATA_PROVIDER_HEADER = 'x-kuib-data-provider';


// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/core/constants.ts